var CacheConstants = /** @class */ (function () {
    function CacheConstants() {
    }
    CacheConstants.DTV_CATALOG = 'dtvcatalog';
    CacheConstants.LOGIN = 'login';
    CacheConstants.COLOR_FOR_PRODUCTS = 'coloursForProducts';
    CacheConstants.SALES_OFFER = 'salesOffer';
    CacheConstants.PLANNED_MAINTENANCE = 'plannedMaintenance';
    return CacheConstants;
}());
export { CacheConstants };
